import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
`;

export const Star = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 48px;
  font-size: 14px;
  font-weight: bold;
  flex-shrink: 0;
  background-size: 100%;
  background-repeat: no-repeat;
  background-image: url('/images/star-filter.svg');
  color: ${({ theme }) => theme.starsFilter.color};
  margin-top: 8px;

  &.active {
    background-image: url('/images/star-filter-active.svg');
    color: ${({ theme }) => theme.starsFilter.active};
  }
`;
